/** @format */

import { useState, useEffect } from "react";

import {
  storage,
  uploadBytesResumable,
  getDownloadURL,
  ref,
} from "../firebase/utils";

const useStorage = (file) => {
  const [progress, setProgress] = useState(0);
  const [url, setUrl] = useState(null);
  const [err, setErr] = useState("");

  useEffect(() => {
    if (!file) {
      return;
    }

    const storageRef = ref(storage, `/profile/${file?.name}`);
    const uploadTask = uploadBytesResumable(storageRef, file);

    uploadTask.on(
      "state_changed",
      (snapShot) => {
        const progress = Math.round(
          (snapShot.bytesTransferred / snapShot.totalBytes) * 100
        );
        setProgress(progress);
      },
      (err) => {
        setErr(err);
      },
      async () => {
        const url = await getDownloadURL(uploadTask.snapshot.ref);
        setUrl(url);
        setProgress(0);
      }
    );

    return () => {
      console.log("Memory Leaks");
    };
  }, [file]);

  return { progress, url, err, setErr, setUrl };
};

export default useStorage;
